export default () => {
	if (document.querySelector('#print')) {
		const printBlock = (dom) => {
			document.querySelectorAll('.tvshow .calendar li:not(.active)').forEach((el) => el.remove())
			document.querySelector('.city').remove()
			document.querySelector('#print').remove()

			const details = document.querySelector(dom).innerHTML

			document.querySelector('.viewport-wrapper').innerHTML = document.body.innerHTML = details

			window.print()
			window.location.reload()
		}

		document.querySelector('#print').addEventListener('click', function () {
			printBlock('.site-body')
		})
	}
}
